// 화면 경로 → 권한 키 표 (spec R-FE-02, 5.4.2). 사이드바(src/pages/Layout.jsx)와 새로고침 시 화면 유지 판단이 이 표 하나를 쓴다.
// 매핑 정본: API 리포 src/access/__fixtures__/legacy-oracle.ts 의 legacyPathPermissionKey / AD_RECEPTION_PATHS.
// 권한 판단은 hasPermission(key) 하나로 한다(src/context/AccessContext.js). 메뉴를 추가하면 ACCESS_RULES와 SIDEBAR_MENU를 함께 고친다.

// 접근 가능한 메뉴가 하나도 없을 때 보여주는 화면 (R-FE-05)
export const NO_ACCESS_PATH = "/no-access";

// 광고 접수관리 메뉴 (주석 처리된 /ads/add-kakao-friend/management 제외)
export const AD_RECEPTION_PATHS = [
  "/ads/campaign/list",
  "/ads/blog/management",
  "/ads/newsRelease/management",
  "/ads/reviewDelete/list",
  "/ads/momcafe-carrot/management",
  "/ads/partner-cafe/management",
  "/ads/biz-profile/management",
  "/ads/experience-reviewer/management",
  "/ads/branding-package/management",
  "/ads/logo-design/management",
  "/ads/follow-on-daangn/management",
  "/ads/review/management",
  "/ads/shopping/management",
  "/ads/tv-ad/management",
  "/ads/tenant-brokerage-fee/management",
];

// 위에서부터 첫 매칭 우선. exact: 경로 일치, prefix: 접두사로 시작. 어느 규칙에도 없으면 불허.
export const ACCESS_RULES = [
  { exact: ["/dashboard"], requires: "dashboard.read" }, // 대시보드
  { exact: ["/blog-analysis-registry"], requires: "blog_analysis.registry.read" }, // 블로그 분석 DB
  { exact: ["/users/password"], requires: "account.password.update" }, // 비밀번호 변경
  { exact: ["/users/create"], requires: "member.create" }, // 회원 등록
  { exact: ["/users"], prefix: ["/users/detail/"], requires: "member.read" }, // 회원 목록·상세
  { prefix: ["/rewards/"], requires: "reward.read" }, // 리워드 관리
  { exact: AD_RECEPTION_PATHS, requires: "ad.reception.read" }, // 광고 접수관리
  { prefix: ["/reward-admin/"], requires: "reward_admin.read" }, // 리워드어드민
  {
    exact: [
      "/ads/campaign/verify",
      "/ads/campaign/trash",
      "/ads/products",
      "/ads/newsRelease/categories",
    ],
    // 광고 환경설정 목록에서 진입하는 write/detail
    prefix: ["/ads/product/", "/ads/newsRelease/category/"],
    requires: "ad.settings.read",
  }, // 광고 환경설정
  { exact: ["/ads/invoice"], requires: "ad.invoice.read" }, // [결제]계산서 발행
  { prefix: ["/wallet/"], requires: "wallet.read" }, // 지갑 관리
  { exact: ["/ads/revenue-analysis"], requires: "ad.revenue_analysis.read" }, // 매출분석
  { prefix: ["/ads/settlement/"], requires: "ad.settlement.read" }, // 정산 관리
  { prefix: ["/access/"], requires: "access.permission.read" }, // 권한 관리 (신규)
];

// 사이드바 메뉴. 순서가 곧 '권한이 있는 첫 메뉴'(홈 경로) 순서다. 각 항목의 노출 여부는 ACCESS_RULES로 판단한다.
export const SIDEBAR_MENU = [
  { id: "dashboard", label: "대시보드", to: "/dashboard" },
  {
    id: "adReception",
    label: "광고 접수관리",
    items: [
      { to: "/ads/campaign/list", label: "[캠페인]신청 관리" },
      { to: "/ads/blog/management", label: "[블로그상품]신청 관리" },
      { to: "/ads/newsRelease/management", label: "[언론배포]신청 관리" },
      { to: "/ads/reviewDelete/list", label: "[리뷰삭제]신청 관리" },
      { to: "/ads/momcafe-carrot/management", label: "[맘카페,당근]신청관리" },
      { to: "/ads/partner-cafe/management", label: "[제휴 카페]신청 관리" },
      { to: "/ads/biz-profile/management", label: "[당근 비즈 프로필 후기]신청 관리" },
      { to: "/ads/experience-reviewer/management", label: "[체험단]신청관리" },
      { to: "/ads/branding-package/management", label: "[촬영패키지]신청관리" },
      { to: "/ads/logo-design/management", label: "[로고디자인]신청관리" },
      { to: "/ads/follow-on-daangn/management", label: "[ETC 미션]신청관리" },
      { to: "/ads/review/management", label: "[리뷰 등록]신청 관리" },
      { to: "/ads/shopping/management", label: "[쇼핑 리워드]신청 관리" },
      { to: "/ads/tv-ad/management", label: "[TV 광고]신청 관리" },
      { to: "/ads/tenant-brokerage-fee/management", label: "[임차인 중개보수]신청 관리" },
    ],
  },
  {
    id: "user",
    label: "회원 관리",
    items: [
      { to: "/users", label: "회원 목록", end: true },
      { to: "/users/create", label: "회원 등록" },
    ],
  },
  {
    id: "reward",
    label: "리워드 관리",
    items: [
      { to: "/rewards/users", label: "회원 목록" },
      { to: "/rewards/settlement", label: "출금 관리" },
    ],
  },
  {
    id: "rewardAdmin",
    label: "리워드어드민",
    items: [
      { to: "/reward-admin/campaign-management", label: "캠페인 관리" },
      { to: "/reward-admin/consumption-volume", label: "소진물량 확인" },
    ],
  },
  {
    id: "adSettings",
    label: "광고 환경설정",
    items: [
      { to: "/ads/campaign/verify", label: "[캠페인]검수 관리" },
      { to: "/ads/campaign/trash", label: "[캠페인]휴지통 관리" },
      { to: "/ads/products", label: "[상품]상품 관리" },
      { to: "/ads/newsRelease/categories", label: "[언론배포]카테고리 관리" },
      { to: "/ads/invoice", label: "[결제]계산서 발행" },
    ],
  },
  {
    id: "wallet",
    label: "지갑 관리",
    items: [
      { to: "/wallet/dashboard", label: "지갑 대시보드" },
      { to: "/wallet/charge", label: "충전/입금 관리" },
      { to: "/wallet/payment", label: "결제/차감 관리" },
      { to: "/wallet/cancel", label: "취소/원복 관리" },
      { to: "/wallet/withdrawal", label: "출금 요청 관리" },
      { to: "/wallet/policy", label: "정책 설정" },
    ],
  },
  { id: "revenueAnalysis", label: "매출분석", to: "/ads/revenue-analysis" },
  { id: "blogAnalysis", label: "블로그 분석 DB", to: "/blog-analysis-registry" },
  {
    id: "settlementManagement",
    label: "정산 관리",
    items: [
      { to: "/ads/settlement/referral-management", label: "추천인 관리" },
      { to: "/ads/settlement/campaign-history", label: "캠페인 내역" },
      { to: "/ads/settlement/settlement-management", label: "정산 관리" },
    ],
  },
  {
    id: "access",
    label: "권한 관리",
    items: [
      { to: "/access/permissions", label: "기능별 보기" },
      { to: "/access/admins", label: "사람별 보기" },
      { to: "/access/roles", label: "역할 편집" },
      { to: "/access/audit-logs", label: "변경 이력" },
    ],
  },
  { id: "password", label: "비밀번호 변경", to: "/users/password" },
];

// 끝 슬래시 제거 ("/dashboard/" → "/dashboard", "/" 는 그대로)
const normalizePath = (pathname) => (pathname || "").replace(/\/+$/, "") || "/";

/** 경로에 필요한 권한 키. 표에 없는 경로면 null(불허).
 * @param {string} pathname @returns {string|null} */
export function requiredPermission(pathname) {
  const path = normalizePath(pathname);
  const rule = ACCESS_RULES.find(
    ({ exact = [], prefix = [] }) =>
      exact.includes(path) || prefix.some((p) => path.startsWith(p)),
  );
  return rule ? rule.requires : null;
}

/** @param {string} pathname @param {(key: string) => boolean} hasPermission @returns {boolean} */
export function canAccessPath(pathname, hasPermission) {
  if (typeof hasPermission !== "function") return false;
  const key = requiredPermission(pathname);
  return key ? hasPermission(key) === true : false;
}

/** 사이드바 메뉴 경로를 메뉴 순서대로 펼친 목록 */
export function getMenuPaths() {
  return SIDEBAR_MENU.flatMap((menu) => (menu.items ? menu.items.map((item) => item.to) : [menu.to]));
}

/** 홈 경로 = 메뉴 순서상 권한이 있는 첫 경로. 하나도 없으면 '권한 없음' 화면 (R-FE-05).
 * @param {(key: string) => boolean} hasPermission @returns {string} */
export function getHomePath(hasPermission) {
  return getMenuPaths().find((path) => canAccessPath(path, hasPermission)) ?? NO_ACCESS_PATH;
}

/** 자동 로그인 직후 이동할 경로. 현재 화면 유지면 null.
 * @param {string} pathname @param {(key: string) => boolean} hasPermission @returns {string|null} */
export function resolvePostLoginPath(pathname, hasPermission) {
  if (normalizePath(pathname) === "/" || !canAccessPath(pathname, hasPermission)) {
    const home = getHomePath(hasPermission);
    return normalizePath(pathname) === home ? null : home;
  }
  return null;
}
